import "./style.scss";
import Logo from "@/src/assets/Footer/footer-logo.png";
import LeaveForm from "@/src/components/LeaveForm/LeaveForm";
import Map from "@/src/components/Map/Map";
import { footerNavLinks } from "@/src/constants/footer";

const FooterDesk = () => {
  return (
    <section className="footer section-margin-top">
      <div className="footer-top">
        <div className="container">
          <div className="footer-message">
            <div className="footer-message-logo">
              <img src={Logo} alt="Logo" />
            </div>
            <div className="footer-message-text">
              <div className="footer-message-title">
                <p>Хотите узнать больше? Напишите нам!</p>
              </div>
              <div className="footer-message-description">
                <p>
                  <strong>Мальтийская школа медицины и бизнеса</strong> будет рада ответить на ваши вопросы.
                </p>
              </div>
            </div>
            <div className="footer-message-form">
              <LeaveForm />
            </div>
          </div>
          <div className="footer-links">
            {footerNavLinks.map((link) => (
              <div className="footer-link" key={link.id}>
                <div className="footer-link-title">
                  <p>{link.title}</p>
                </div>
                <div className="footer-link-items">
                  {link.links.map((item) =>
                    item.link ? (
                      <a key={item.id} href={item.link}>
                        {item.name}
                      </a>
                    ) : (
                      <p key={item.id}>{item.name}</p>
                    )
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="footer-map">
            <Map />
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>Мальтийская школа медицины и бизнеса</p>
      </div>
    </section>
  );
};

export default FooterDesk;
